import ApiPermisos from './../../services/apiPermisos'

export default {
  namespaced: true,
  state: {
    process: {
      status: 0, // 1, 2, 3, 4, 5
      summons: null, //0 or null
      record: null,  // 0 or null1
      penalty: null,  // 1 or null
      penaltyRecord: null,  // 0 or null
      resource: null,  // 0 or null
      resourceResponse: null,// 0 or null
      template: '',
      file: '',
      dateLimitState: null,
      daysLimitState: null

    },
    report: {
      date_knowledge: "",
    },
    penalties: [],
    employee: {
      core_employee: {
        society: {
          name: "",
          work_regulations: ''
        },
        labor_unions: []
      },
      proce_citations: [],
      proce_labor_relations: [],
      proce_diligences: [],
      proce_comments: [],
      proce_penalty: {
        labor_relations: 0
      },
    },
    processes: [],
    loading: false,
    categories: [],
    questions: [],
  },
  getters: {

  },
  mutations: {
    setEmployee: (state, employee) => {
      for (let index = 0; index < employee.proce_citations.length; index++) {
        let h = employee.proce_citations[index]['date'].split(' ');
        h[0] = h[0].split('-');
        h[1] = h[1].split(':');
        h[1][2] = 'am';
        let month = [
          "ENE",
          "FEB",
          "MAR",
          "ABR",
          "MAY",
          "JUN",
          "JUL",
          "AGO",
          "SEP",
          "OCT",
          "NOV",
          "DIC",
        ]
        if (h[1][0] > 12) {
          h[1][2] = 'pm';
          h[1][0] = h[1][0] - 12;
        }
        employee.proce_citations[index]['day'] = h[0][2] + ' de ' + month[h[0][1] - 1] + ', ' + h[0][0];
        employee.proce_citations[index]['hour'] = h[1][0] + ':' + h[1][1] + ' ' + h[1][2];
      }
      state.employee = employee;
    },
    setReport: (state, report) => {
      state.report = report;
    },
    setPenalties: (state, penalties) => {
      state.penalties = penalties;
    },
    setStatus: (state, status) => {
      let processTmp = state.process;
      processTmp.status = status;
      state.process = processTmp;
    },
    setFile: (state, file) => {
      state.process.file = file;
    },
    setEditorData: (state, obj) => {
      //let editorData = state.process.editorData;
      //state.process.editorData = editorData.replace("$" + obj.key, obj.value);
      //htmlObject.innerHTML = s;
      var dom = document.createElement('div');
      var textNode = document.createTextNode(state.process.editorData);
      dom.appendChild(textNode);
      //dom.innerHTML = "**" + Math.random();
      //alert(dom.querySelector("." + obj.key).innerHTML);
      var targetElement = dom.querySelector("." + CSS.escape(obj.key));
      if (targetElement) {
        var span = document.createElement('span');
        span.setAttribute('attr', obj.key);
        span.textContent = obj.value;
        targetElement.innerHTML = '';
        targetElement.appendChild(span);
    }
      //console.log(obj);
      //let content = state.process.editorData.innerHTML;
      //console.log(document.querySelector(obj.key));
      //dom.querySelector(obj.key).innerHTML = obj.value;
      //state.process.editorData = dom;
    },
    setProcesses: (state, processes) => {
      state.processes = processes;
    },
    setLoading: (state, loading) => {
      state.loading = loading;
    },
    setDateLimitState: (state, date) => {
      state.process.dateLimitState = date;
    },
    setDaysLimitState: (state, days) => {
      state.process.daysLimitState = days;
    },
    setQuestionCategories: (state, categories) => {
      state.categories = categories;
    },
    setQuestions: (state, questions) => {
      state.questions = questions;
    },
  },
  actions: {
    actGetEmployee: async ({
      commit,
    }, id) => {
      await ApiPermisos.getProceEmployee(id).then((response) => {
        commit('setEmployee', response.data);
        commit('setStatus', response.data.proce_state_id);
      })
    },
    actUptEmployee: ({
      commit,
    }, data) => {
      ApiPermisos.uptProceEmployee(data).then((response) => {
        commit('setEmployee', response.data);
      })
    },
    actGetReport: async ({
      commit,
    }, id) => {
      await ApiPermisos.getReport(id).then((response) => {
        commit('setReport', response.data);
      })
    },
    actAddCitation: ({
      commit,
    }, data) => {
      ApiPermisos.addReportEmployeeCitation(data).then((response) => {
        commit('setEmployee', response.data);
      })
    },
    actUpdCitation: ({
      commit,
    }, data) => {
      ApiPermisos.updReportEmployeeCitation(data).then((response) => {
        commit('setEmployee', response.data);
      })
    },
    actCancelCitation: ({
      commit,
    }, id) => {
      ApiPermisos.cancelReportEmployeeCitation(id).then((response) => {
        commit('setEmployee', response.data);
      })
    },
    actAddLaborRelations: ({
      commit,
    }, data) => {
      ApiPermisos.addReportLaborRelations(data).then((response) => {
        commit('setEmployee', response.data);
      })
    },
    actAddLaborRelationsComment: ({
      commit,
    }, data) => {
      ApiPermisos.addReportLaborRelationsComment(data).then((response) => {
        commit('setEmployee', response.data);
      })
    },
    actAddDiligence: ({
      commit,
    }, data) => {
      ApiPermisos.addReportDiligence(data).then((response) => {
        commit('setEmployee', response.data);
      })
    },
    actUdtDiligence: ({
      commit,
    }, data) => {
      ApiPermisos.updtReportDiligence(data).then((response) => {
        commit('setEmployee', response.data);
      })
    },
    actGetPenalties: ({
      commit,
    }, data) => {
      ApiPermisos.getProcePenalties(data).then((response) => {
        commit('setPenalties', response.data);
      })
    },
    actAddPenaltyEvidence: ({
      commit,
    }, data) => {
      ApiPermisos.addProcePenaltyEvidence(data).then((response) => {
        commit('setEmployee', response.data);
      })
    },
    actUpdPenaltyEvidence: ({
      commit,
    }, data) => {
      ApiPermisos.updProcePenaltyEvidence(data).then((response) => {
        commit('setEmployee', response.data);
        return response.data;
      })
    },
    actGeneratePDF: async ({
      commit,
    }, data) => {
      let response = await ApiPermisos.generatePDF(data);
      commit('setFile', response.data.file);
      return response;
    },
    actGetProcesses: async ({
      commit,
    }) => {
      commit('setLoading', true); // Start loading
      await ApiPermisos.getProcesses().then((response) => {
        commit('setProcesses', response.data);
        commit('setLoading', false); // End loading
      })
    },
    actGetCalendarDays: ({
      commit,
    }, data) => {
      ApiPermisos.getCalendarDays(data).then((response) => {
        commit('setDateLimitState', response.data.endDate);
        commit('setDaysLimitState', response.data.calendarDays);
      })
    },
    actGetQuestionCategories: ({
      commit,
    }) => {
      ApiPermisos.getQuestionCategories().then((response) => {
        commit('setQuestionCategories', response.data);
      })
    },
    actGetQuestions: ({
      commit,
    }) => {
      ApiPermisos.getQuestions().then((response) => {
        commit('setQuestions', response.data);
      })
    },
  },
}
